const stripeKey =
  'pk_test_51IuuJXFStIVWbyOCVVWVyvNEw65lcprJYRXVw82QqiNd3XSwIS0A1B8DpOOjrBW5IakemRqfvtmkyjyhcVqJONnk00XRTWZ4Bc';
// const contactPhone = "8337521769";
const contactPhone = "8334331371";
export { stripeKey, contactPhone };
